import React, { useEffect, useState } from "react";

import { PaymentStatusComp } from "@tm/static";

import { getAnalytics } from "@tm/insurance/analytics";
import { navigationActions } from "@tm/insurance/navigation";
import { setTravDetailsInMemory } from "@tm/insurance/utils";
import {
  PASSPORT_DETAILS_PAGE_ID,
  TXN_SUCCESS_REDIRECT_TIME,
} from "@tm/isomorphic-utils";
import { Confetti } from "@tm/static/icons";
import { usePlanType } from "@tm/ui";
const analytics = getAnalytics();

const InsurancePaySuccess = () => {
  const [paymentMethod, setPaymentMethod] = useState<string | null>("");
  const [bookingId, setBookingId] = useState<string | null>("");
  const [refId, setRefId] = useState<string | null>("");
  const { type } = usePlanType();

  useEffect(() => {
    analytics?.trackPageLoadEvent({
      pageName: "PAYMENT",
      bookingStatus: "success",
    });
    // const queryParams = new URLSearchParams(window.location.search);
    // const bookingId = queryParams.get("bookingId");
    // const paymentMethod = queryParams.get("paymentMethod");
    // initializePageTracking(
    //   {
    //     page_context: {
    //       page_name: "payment",
    //       page_type: "funnel",
    //       funnel_step: "thankyou",
    //       subpage_name: "payment_success",
    //     },
    //     event_detail: {
    //       booking_info: {
    //         booking_id: bookingId || "",
    //         status: "success",
    //         payment_method: paymentMethod || "",
    //       },
    //     },
    //   },
    //   {
    //     isReadStoreSearchContext: true,
    //   }
    // );
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const passportRequired = queryParams.get("passportRequired");

    const paymentMethod = queryParams.get("paymentMethod");
    setPaymentMethod(paymentMethod);

    const bookingId = queryParams.get("bookingId");
    setBookingId(bookingId);
    const internalSource =
      queryParams.get("cmp") ||
      queryParams.get("internal_source") ||
      (typeof window !== "undefined" &&
        sessionStorage.getItem("internal_source")) ||
      "fallback_thankyou";


    const itineraryId = queryParams.get("itineraryId");
    const refId = queryParams.get("refId");
    setRefId(refId);

    setTravDetailsInMemory({});

    const timer = setTimeout(() => {
      if (passportRequired === "true") {
        navigationActions.navigateToAddPassport({
          bookingId,
          pageId: PASSPORT_DETAILS_PAGE_ID.PAYMENT_SUCCESS,
        });
      } else {
        navigationActions.navigateToOrderConfirmed({
          bookingId,
          type: type || "",
          itineraryId: itineraryId || "",
          internal_source: internalSource,
        });
      }
    }, TXN_SUCCESS_REDIRECT_TIME);

    return () => {
      clearTimeout(timer);
    };
  }, [bookingId]);

  return (
    <React.Fragment>
      <PaymentStatusComp
        title="Payment Successful"
        infoTxt={`${paymentMethod ? `Paid using: ${paymentMethod}` : ""}`}
        subInfoTxt={`${refId ? `Ref. Number: ${refId}` : ""}`}
        imageIcon={<Confetti />}
      />
    </React.Fragment>
  );
};

export default InsurancePaySuccess;
